import "../style.scss";
import { IonButton, IonContent, IonModal, IonText } from "@ionic/react";
import { FC, useEffect, useState } from "react";

import { ReasonText } from "./reasonText";
import { LearnMorePrivacyPolicyText } from "../learnMorePrivacyPolicyText";
import { AlwaysAllowLocationPrimerModalProps } from "../model";
import { isOsWithoutAlwaysAllowOption } from "../utils";

export function AlwaysAllowLocationPrimerModal(
  props: AlwaysAllowLocationPrimerModalProps
): ReturnType<FC<AlwaysAllowLocationPrimerModalProps>> {
  const { isOpen, onGoToLocationSettingClicked } = props;

  const [isOsWithoutAlwaysAllow, setIsOsWithoutAlwaysAllow] = useState(false);

  useEffect(() => {
    if (isOpen) {
      isOsWithoutAlwaysAllowOption()
        .then((result) => setIsOsWithoutAlwaysAllow(result))
        .catch(() => setIsOsWithoutAlwaysAllow(false));
    }
  }, [isOpen]);

  return (
    <IonModal
      isOpen={isOpen}
      backdropDismiss={false}
      cssClass="always-allow-primer-modal"
      mode="ios"
      data-testid="always-allow-primer-modal"
    >
      <IonContent>
        <div className="modal-body primer-modal">
          <div className="bunny-icon">
            <img src="assets/logo/bunny.png" alt="Clipboard logo" />
          </div>
          <span className="modal-title">Enable location permissions</span>
          <IonText className="message">
            <ReasonText locationIsAlwaysShared={!isOsWithoutAlwaysAllow} />
          </IonText>
          <IonText className="message">
            We collect and use this location information to confirm to facilities that you are on
            your way to an upcoming shift, show you nearby Urgent Shifts, and verify your completion
            of shifts in order to distribute your earnings via InstantPay.
          </IonText>
          <IonText className="message">
            <LearnMorePrivacyPolicyText />
          </IonText>

          <div className="action-container">
            <IonButton
              mode="ios"
              color="primary"
              className="allow-location-btn"
              onClick={() => onGoToLocationSettingClicked?.()}
            >
              Go To Settings
            </IonButton>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
}
